import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

interface ColumnDef {
  key: string
  label: string
  type: string // string, number, datetime, boolean
}

interface DataSource {
  key: string
  label: string
  columns: ColumnDef[]
  group_by_options: string[]
}

interface DataSourcesResponse {
  data_sources: DataSource[]
}

export function useReportDataSources() {
  return useQuery({
    queryKey: ['report-data-sources'],
    queryFn: () => api.get<DataSourcesResponse>('/reports/data-sources').then((r) => r.data.data_sources),
    staleTime: 5 * 60 * 1000,
  })
}

export type { DataSource, ColumnDef }
